
const emptyBeeForm: any = {
    "page": {
        "body": {
            "container": {
                "style": {
                    "background-color": "#FFFFFF"
                }
            },
            "content": {
                "computedStyle": {
                    "linkColor": "#0000FF",
                    "messageBackgroundColor": "transparent",
                    "messageWidth": "600px"
                },
                "style": {
                    "color": "#000000",
                    "font-family": "Arial, Helvetica Neue, Helvetica, sans-serif"
                }
            },
            "type": "mailup-bee-page-properties",
            "webFonts": [
                {
                    "fontFamily": "Arial, 'Helvetica Neue', Helvetica, sans-serif",
                    "name": "Arial",
                    "url": ""
                }
            ]
        },
        "description": "",
        "rows": [
            {
                "columns": [
                    {
                        "grid-columns": 12,
                        "modules": [
                            {
                                "type": "mailup-bee-newsletter-modules-form",
                                "descriptor": {
                                    "form": {
                                        "structure": {
                                            "title": "",
                                            "description": "",
                                            "attributes": {},
                                            "fields": {},
                                            "layout": []
                                        },
                                        "attributes": {},
                                        "style": {
                                            "labels": {
                                                "color": "#000000",
                                                "line-height": "200%",
                                                "font-weight": "",
                                                "font-style": "",
                                                "text-align": "left",
                                                "label-position": "top",
                                                "letter-spacing": "0",
                                                "min-width": "0"
                                            },
                                            "fields": {
                                                "color": "#000000",
                                                "backgroundColor": "#ffffff",
                                                "outlineColor": "#3AAEE0",
                                                "border-top": "1px solid transparent",
                                                "border-right": "1px solid transparent",
                                                "border-bottom": "1px solid transparent",
                                                "border-left": "1px solid transparent",
                                                "padding-top": "5px",
                                                "padding-right": "5px",
                                                "padding-bottom": "5px",
                                                "padding-left": "5px",
                                                "border-radius": "4px"
                                            },
                                            "buttons": {
                                                "backgroundColor": "#3AAEE0",
                                                "border-radius": "4px",
                                                "border-top": "0px solid transparent",
                                                "border-right": "0px solid transparent",
                                                "border-bottom": "0px solid transparent",
                                                "border-left": "0px solid transparent",
                                                "color": "#ffffff",
                                                "line-height": "200%",
                                                "text-align": "center",
                                                "width": "100%",
                                                "letter-spacing": "0",
                                                "font-weight": "",
                                                "font-style": "",
                                                "max-width": "100%",
                                                "padding-top": "5px",
                                                "padding-right": "20px",
                                                "padding-bottom": "5px",
                                                "padding-left": "20px",
                                                "outer": {
                                                    "padding-top": "0px",
                                                    "padding-right": "0px",
                                                    "padding-bottom": "0px",
                                                    "padding-left": "0px"
                                                }
                                            }
                                        }
                                    },
                                    "style": {
                                        "width": "100%",
                                        "text-align": "center",
                                        "padding-top": "10px",
                                        "padding-right": "10px",
                                        "padding-bottom": "10px",
                                        "padding-left": "10px",
                                        "font-size": "14px",
                                        "font-weight": "400",
                                        "font-family": "inherit",
                                        "background-color": "transparent"
                                    },
                                    "mobileStyle": {},
                                    "computedStyle": {
                                        "class": "center",
                                        "hideContentOnMobile": false,
                                        "hideContentOnDesktop": false
                                    }
                                },
                                "locked": false,
                                "uuid": "42db8494-6274-4a9f-a1a9-6ba8a521d42c"
                            }
                        ],
                        "style": {
                            "background-color": "transparent",
                            "border-bottom": "0px solid transparent",
                            "border-left": "0px solid transparent",
                            "border-right": "0px solid transparent",
                            "border-top": "0px solid transparent",
                            "padding-bottom": "5px",
                            "padding-left": "0px",
                            "padding-right": "0px",
                            "padding-top": "5px"
                        },
                        "uuid": "c24a17bb-f999-4152-bb65-99a874c5cef2"
                    }
                ],
                "container": {
                    "style": {
                        "background-color": "transparent",
                        "background-image": "none",
                        "background-position": "top left",
                        "background-repeat": "no-repeat"
                    }
                },
                "content": {
                    "computedStyle": {
                        "hideContentOnDesktop": false,
                        "hideContentOnMobile": false,
                        "rowColStackOnMobile": true,
                        "rowReverseColStackOnMobile": false,
                        "verticalAlign": "top"
                    },
                    "style": {
                        "background-color": "transparent",
                        "background-image": "none",
                        "background-position": "top left",
                        "background-repeat": "no-repeat",
                        "border-bottom": "0px solid transparent",
                        "border-left": "0px solid transparent",
                        "border-radius": "0px",
                        "border-right": "0px solid transparent",
                        "border-top": "0px solid transparent",
                        "color": "#000000",
                        "padding-bottom": "0px",
                        "padding-left": "0px",
                        "padding-right": "0px",
                        "padding-top": "0px",
                        "width": "600px"
                    }
                },
                "empty": false,
                "locked": false,
                "synced": false,
                "type": "",
                "uuid": "37ca22fd-a005-46f6-86fa-44d398fb03f6"
            }
        ],
        "template": {
            "name": "template-base",
            "type": "basic",
            "version": "2.0.0"
        },
        "title": ""
    },
    "comments": {}
}

export default emptyBeeForm